/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TaxFiling = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.99326 9.2C7.63963 9.2 6.5 10.3021 6.5 11.7069C6.5 13.098 7.62618 14.2 8.99326 14.2C10.3418 14.2 11.5 13.1304 11.5 11.7069C11.5 10.3001 10.3449 9.2 8.99326 9.2ZM8 11.7069C8 11.1398 8.45868 10.7 8.99326 10.7C9.53791 10.7 10 11.1498 10 11.7069C10 12.2623 9.55364 12.7 8.99326 12.7C8.44508 12.7 8 12.26 8 11.7069Z"
                        fill={color}
                    />
                    <path
                        d="M9.60812 18.8555L7.65179 18.8478L14.5437 9.35222L16.5 9.35995L9.60812 18.8555Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.75 16.4673C12.75 15.0625 13.8896 13.9604 15.2433 13.9604C16.5949 13.9604 17.75 15.0605 17.75 16.4673C17.75 17.8908 16.5918 18.9604 15.2433 18.9604C13.8762 18.9604 12.75 17.8584 12.75 16.4673ZM15.2433 15.4604C14.7087 15.4604 14.25 15.9003 14.25 16.4673C14.25 17.0205 14.6951 17.4604 15.2433 17.4604C15.8036 17.4604 16.25 17.0227 16.25 16.4673C16.25 15.9102 15.7879 15.4604 15.2433 15.4604Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M23 22V6H12L9 2H1V22H23ZM2.5 20.5V7.5H21.5V20.5H2.5ZM2.5 3.5H8.251L10.125 6H2.5V3.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
